import type { TimeIntent, TimeIntentOptionValue } from './types';
import { formatRelativeDateForParis, isParisTz, t } from '@frontend/shared';
import type { SegmentedButtonOption } from '@frontend/shared/web';

export const formatTimeIntent = (timeIntent: TimeIntent, withSuffix = true) => {
  let formattedDate = '';

  if (timeIntent.type === 'DA') {
    formattedDate = formatRelativeDateForParis(timeIntent.date);
  } else {
    formattedDate = t('pwa.common.today');
  }

  const time = timeIntent.type === 'DA' ? timeIntent.time : t('pwa.common.asap');

  return `${formattedDate}, ${time}${withSuffix && !isParisTz() ? t('pwa.common.local-time') : ''}`;
};

export const timeIntentOptions: SegmentedButtonOption<TimeIntentOptionValue>[] = [
  {
    label: t('pwa.common.go-at'),
    value: 'DEPARTURE',
  },
  {
    label: t('pwa.common.arrive-at'),
    value: 'ARRIVAL',
  },
];
